import "../assets/index-5fa0ac5a.css";
import { defineComponent as t } from "vue";
import { G as o } from "../chunks/GenRandomId-cb9ccebe.mjs";
import { n as a } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const r = t({
  name: "NcActionButtonGroup",
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: !1
    }
  },
  props: {
    /**
     * Optional text shown below the button group
     */
    name: {
      required: !1,
      default: void 0,
      type: String
    }
  },
  computed: {
    labelId() {
      return `nc-action-button-group-${o()}`;
    }
  }
});
var s = function() {
  var n = this, e = n._self._c;
  return n._self._setupProxy, e("li", { staticClass: "nc-button-group-base", attrs: { role: n.isInSemanticMenu && "presentation" } }, [n.name ? e("div", { attrs: { id: n.labelId } }, [n._v(" " + n._s(n.name) + " ")]) : n._e(), e("ul", { staticClass: "nc-button-group-content", attrs: { role: "group", "aria-labelledby": n.name ? n.labelId : void 0 } }, [n._t("default")], 2)]);
}, l = [], u = /* @__PURE__ */ a(
  r,
  s,
  l,
  !1,
  null,
  null,
  null,
  null
);
const p = u.exports;
export {
  p as default
};
